interface ConvictionSliderProps {
  lean: number;
  setLean: (value: number) => void;
  optionA: string;
  optionB: string;
}

export function ConvictionSlider({ lean, setLean, optionA, optionB }: ConvictionSliderProps) {
  const distance = Math.abs(lean);
  const certaintyWord = distance < 16 ? 'suspended' : distance < 48 ? 'leaning' : distance < 78 ? 'decided' : 'pulled hard';
  return (
    <section className="convictionSlider" aria-labelledby="conviction-title">
      <div className="sliderHeader">
        <h3 id="conviction-title">Place the felt pull</h3>
        <span>{certaintyWord}</span>
      </div>
      <div className="poleLabels">
        <span>{optionA}</span>
        <span>middle</span>
        <span>{optionB}</span>
      </div>
      <input
        aria-label="Felt pull between the two options. This direction is kept locally only."
        type="range"
        min={-100}
        max={100}
        value={lean}
        onChange={(event) => setLean(Number(event.target.value))}
      />
      <div className="fieldLine" aria-hidden="true">
        <i style={{ left: `${50 + lean / 2}%`, width: `${Math.max(8, distance / 1.2)}%` }} />
      </div>
      <p className="microcopy">The shared database receives only distance from the middle, not which side you chose.</p>
    </section>
  );
}
